import React from "react";

import { Container } from "components/organisms/Grid";
import { mapModifiers } from "helpers/component";

type Modifiers = "no-horizontal-spacing";

export interface Props {
	modifiers?: Modifiers | Array<Modifiers>;
	backgroundColor?: string;
	fluid?: boolean;
	children?: React.ReactNode;
	useDiv?: boolean;
	id?: string;
	isBorderBottom?: boolean;
	isBorderTop?: boolean;
}

export const Section: React.FC<Props> = ({
	useDiv,
	children,
	fluid,
	modifiers,
	id,
	backgroundColor,
	isBorderBottom,
	isBorderTop,
}) => {
	return useDiv ? (
		<div
			className={mapModifiers(
				"o-section",
				modifiers,
				backgroundColor && "hasBackgroundColor",
				isBorderBottom && "hasBorderBottom",
				isBorderTop && "hasBorderTop"
			)}
			style={{ backgroundColor }}
			id={id}
		>
			<Container className="o-section_container" fluid={fluid}>
				{children}
			</Container>
		</div>
	) : (
		<section
			className={mapModifiers(
				"o-section",
				modifiers,
				backgroundColor && "hasBackgroundColor",
				isBorderBottom && "hasBorderBottom",
				isBorderTop && "hasBorderTop"
			)}
			style={{ backgroundColor }}
			id={id}
		>
			<Container className="o-section_container" fluid={fluid}>
				{children}
			</Container>
		</section>
	);
};
